
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const DropboxOrders = lazy(() => import('../pages/dropbox-orders/page'));
const Testimonials = lazy(() => import('../pages/testimonials/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/dropbox-orders',
    element: <DropboxOrders />,
  },
  {
    path: '/testimonials',
    element: <Testimonials />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
